export class LabelViewModel {
  name: string = '';
  sku: string = '';
  price: number = 0;
  sizeSize: string = '';
  color: string = '';
  quantityToPrint: number = 0;
  printFormat: number | null = null;
  departmentId: number | null = null;
  departmentName: string | null = null;
  categoryId: number | null = null;
  categoryName: string | null = null;
  subCategoryId: number | null = null;
  subCategoryName: string | null = null;
  storeId: number | null = null;
  storeName: string | null = null;
  brandId: number | null = null;
  brandName: string | null = null;
  productionCycle: string | null = null;
}
export class LabelFormatViewModel {
  formatTypeId: number = 0;
  formatTypeDesr: string = '';
  frontPreview: string = '';
  backPreview: string = '';
  zplCode: string = '';
  labelType: number = 0;
  formatTypeCd: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserId: number = 0;
  lastChangedByUserId: number = 0;
  printerName: string = '';
  lastChangedDt: string = '';
  userName: string = '';
  companyId: number = 0;
  isSelected: boolean = true;
}
